'use es6';

import Raven from 'Raven';
export const reportZorseUndefined = (extra = {}) => {
  Raven.captureMessage('hubspot.zorse not defined', {
    level: 'warning',
    extra
  });
};